import classNames from 'classnames';
import styles from './Datepicker.module.css';
import { createComponent, type ElementWithProps, boxShadow } from './utils';

export const DateSelect = createComponent('div', {
  className: styles.dateSelect
});

export const Header = createComponent('div', {
  className: styles.header
});

export const Spacer = createComponent('div', {
  className: styles.spacer
});

export const MonthPicker = createComponent('div', {
  className: styles.monthPicker
});

export const MonthTitle = createComponent<ElementWithProps<{ titleStyle?: 'default' | 'center' }>>(
  'div',
  ({ titleStyle }) => ({
    className: classNames(styles.monthTitle, titleStyle === 'center' && styles.monthTitleCenter)
  })
);

export const Calendar = createComponent('div', {
  className: styles.calendar
});

export const Row = createComponent('div', {
  className: styles.row
});

export const CalendarDayOfWeek = createComponent('div', {
  className: classNames(styles.day, styles.calendarDayOfWeek)
});

export interface CalendarDayProps {
  inRange?: boolean;
  inHoveringRange?: boolean;
  isHoverDate?: boolean;
  firstInRange?: boolean;
  lastInRange?: boolean;
  selected?: boolean;
  unavailable?: boolean;
  disabled?: boolean;
  today?: boolean;
}

export const CalendarDay = createComponent<ElementWithProps<CalendarDayProps>>('div', props => ({
  className: classNames(
    styles.calendarDay,
    (props.inRange || props.inHoveringRange) && !props.disabled && styles.inRange,
    props.isHoverDate && !props.disabled && styles.isHoverDate,
    props.lastInRange && props.selected && styles.lastInRange,
    props.firstInRange && props.selected && styles.firstInRange
  )
}));

export const DayButton = createComponent<ElementWithProps<CalendarDayProps>>('button', props => ({
  className: classNames(
    styles.calendarButton,
    styles.dayButton,
    props.today && styles.today,
    props.selected && styles.selected,
    props.selected && (props.firstInRange || props.lastInRange) && styles.selectedInRange,
    (props.inRange || props.inHoveringRange) && styles.inRangeButton,
    props.unavailable && !props.disabled && styles.spilloverAvailable,
    props.unavailable && props.disabled && styles.unavailable
  ),
  style: {
    '--shadow-focus-visible': boxShadow.focusVisible
  },
  disabled: props.disabled && !props.unavailable
}));
